import { render } from "./safetyRecord.vue?vue&type=template&id=0c7f34f5&scoped=true"
import script from "./safetyRecord.vue?vue&type=script&lang=js"
export * from "./safetyRecord.vue?vue&type=script&lang=js"

import "./safetyRecord.vue?vue&type=style&index=0&id=0c7f34f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7f34f5"]])

export default __exports__